import VueRouter, { Route } from 'vue-router';

export function initKeycloakRedirectionGuard(router: VueRouter) {
    router.beforeEach((to, _, next) => {
        // this guard only triggers when inside the Keycloak theme pages
        if (!window.kcContext || isInitialNavigation(to)) {
            return next();
        }

        // `realms` is treated as `language` parameter is multilanguage setup by our router
        // we exclude it from the url to navigate to
        window.location.replace(
            window.location.origin + to.fullPath.replace('/realms', ''),
        );
        next(false);
    });
}

function isInitialNavigation(to: Route) {
    // first navigation should always succeed, so we don't enter a redirection loop
    // the homepage doesn't have a `name` associated with it, so we have to explicitly exclude it
    return !to.name && to.path !== '/';
}
